module.exports = __webpack_public_path__ + "img/buenos_aires_nunez.d69829bf.jpg";